import { BaseResponseModel } from '@/app/shared/interface/base-response.interface';
import { Order, OrderItem, OrderShipment, ReturnRequestCreate, ReturnRequestProductCreate } from '@/app/shared/interface/order.interface';
import { Product, ProductModel } from '@/app/shared/interface/product.interface';
import { OrderService } from '@/app/shared/services/order.service';
import { ProductService } from '@/app/shared/services/product.service';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-return-order',
  templateUrl: './return-order.component.html',
  styleUrl: './return-order.component.scss'
})
export class ReturnOrderComponent {
  @Input() inputOrder: Order | undefined;
  @Output() createSuccessEvt = new EventEmitter<boolean>();
  public order: Order | undefined;
  public returnOrder: ReturnRequestCreate | undefined;
  public skusGroup: ProductReturnGroup[] = [];
  private products: Product[] = [];
  constructor(
    private orderService: OrderService,
    private notiService: ToastrService,
    private productService: ProductService,
  ) {

  }
  ngOnInit() {
    if (this.inputOrder) {
      this.order = this.inputOrder;
      this.createReturnOrderModel();
      if (this.order && this.order.shipments) {
        let allSkus = this.order.shipments.flatMap(s => s.shipmentItems?.map(i => i.productSku) || []);
        let comboSkus = this.order.shipments.flatMap(s => s.shipmentItems?.filter(i => i.combo_ProductSku).map(i => i.combo_ProductSku!) || []);
        allSkus = allSkus.concat(comboSkus);
        const body = JSON.stringify({ productSkus: allSkus, limit: allSkus.length });
        this.productService.getProductsForMember(body).subscribe({
          next: (res: ProductModel) => {
            this.products = res?.products || res;
            this.skusGroup = this.convertToSkuGroup(this.order!.shipments!, this.products);
          },
          error: (err) => {
            console.error('Không lấy được sản phẩm:', err);
          }
        });

      } else {
        this.skusGroup.length = 0;
      }
    }
  }

  convertToSkuGroup(shipments: OrderShipment[], products: Product[]): ProductReturnGroup[] {
    const res = new Array<ProductReturnGroup>();
    
    shipments.forEach(shipment => {
      shipment.shipmentItems!.forEach(item => {
        let productInfo = products.find(p => p.sku == item.productSku || p.skU2 == item.productSku);
        let orderItem = this.order?.items.find(i => i.sku === item.productSku || i.skU2 === item.productSku);

        let data = {
          productSku: item.productSku,
          shipments: [],
          productInfo: productInfo,
          expiredDate: orderItem?.expiredDate,
        } as ProductReturnGroup;
        if (item.combo_ProductSku) {
          let comboInfo = products.find(p => p.sku == item.combo_ProductSku || p.skU2 == item.combo_ProductSku);
          data.combo_Info = comboInfo;
          data.producCombo_Sku = item.combo_ProductSku;
        }
        
        data.shipments.push({
          lotNumber: item.lotNumber,
          shipmentId: shipment.shipmentId,
          shipmentCode: shipment.shipmentCode,
          shipmentDate: shipment.shipmentDate,
          quantity: item.quantity,
          expirationDate: item.expiryDate,
          price: item.price || 0,
        });

        res.push(data);
      });
    });

    return res;
  }

  createReturnOrderModel() {
    if (this.order) {
      this.returnOrder = new ReturnRequestCreate();
      this.returnOrder.userName = this.order.userName;
      this.returnOrder.orderId = this.order.orderId;
      this.returnOrder.items = [];
    } else {
      this.returnOrder = undefined;
    }
  }
  quantityChange(item: ReturnRequestProductCreate) {
    if (item.quantity > 0) {
      item.isSelected = true;
    } else {
      item.quantity = 0;
      item.isSelected = false;
    }
  }

  private isSubmitting = false;
  createReturnRequest() {
    if (this.isSubmitting) {
      this.notiService.error("Đang tạo phiếu trả hàng. Vui lòng chờ");
      return;
    }


    if (!this.returnOrder) {
      this.notiService.error("Phiếu trả hàng chưa được tạo");
      return;
    }
    const items = this.skusGroup.flatMap(pg =>
      pg.shipments
        .filter(s => s.selectedQuantity && s.selectedQuantity > 0)
        .map(s => ({
          productSku: pg.productSku,
          combo_ProductSku: pg.producCombo_Sku,
          quantity: s.selectedQuantity!,
          note: s.note,
          shipmentId: s.shipmentId.toString(),
          shipmentCode: s.shipmentCode,
          lotNumber: s.lotNumber,
          quantityInShipment: s.quantity,
          shipmentDate: s.shipmentDate,
          productInfo: pg.productInfo,
          expirationDate: s.expirationDate,
          price: s.price || 0
        } as ReturnRequestProductCreate))
    );
    this.returnOrder.items = items;

    let nonProducts = this.returnOrder.items.filter(p => p.quantity > 0);
    if (nonProducts.length === 0) {
      this.notiService.error(`Chưa chọn SL trả ở sản phẩm nào`);
      return;
    }
    let overProducts = this.returnOrder.items.filter(p => p.quantity > p.quantityInShipment);
    if (overProducts.length) {
      this.notiService.error(`Sản phẩm [${overProducts[0].productInfo?.name}] có số lượng trả vượt quá số lượng giao`);
      return;
    }

    let submitData = {
      ...this.returnOrder
    } as ReturnRequestCreate;
    submitData.items = submitData.items.filter(p => p.quantity > 0);

    this.isSubmitting = true;
    this.orderService.createReturnOrder(submitData).subscribe({
      next: (res: BaseResponseModel) => {
        if (res && res.isSuccess) {
          this.notiService.success("Tạo phiếu thành công");
          this.createSuccessEvt.emit(true);
          // this.router.navigate([`../detail/${res.data.id}`]);
        } else {
          this.notiService.error("Tạo phiếu không thành công. Vui lòng thử lại sau");
        }
      },
      error: (error: any) => {
        this.isSubmitting = false;
        console.error(error);
        let errorMsg = error?.error?.message ?? error?.error?.title ?? "Lỗi không xác định";
        this.notiService.error(`Lỗi lấy tạo phiếu. Vui lòng thử lại sau.`)
      },
      complete: () => {
        this.isSubmitting = false;
      }
    })
  }
  returnCancel() {
    this.createSuccessEvt.emit(false);
  }

  getProductImage(product: Product | undefined): string {
    if (product?.imageUrls && product.imageUrls.length > 0) {
      return product.imageUrls[0];
    }
    return 'assets/images/product.png';
  }
}

export interface ProductReturnGroup {
  productInfo?: Product;
  combo_Info?: Product;
  productSku: string;
  producCombo_Sku?: string;
  shipments: ShipmentInfo[];
  expiredDate?: string | null;
}

export interface ShipmentInfo {
  lotNumber: string | undefined;
  shipmentId: number;
  shipmentCode: string;
  shipmentDate: string | undefined;
  quantity: number;
  note?: string;             // ghi chú
  selectedQuantity?: number; // số lượng user chọn để trả
  expirationDate: string | undefined;
  price: number
}
